module.exports = __webpack_public_path__ + "static/img/map.22469506.jpg";